import React, {useEffect, useMemo, useState} from "react";
import BlankModal from "@core/modal/BlankModal";
import {AiOutlineCloseCircle} from "react-icons/ai";
import API from "@utils/plugins/API";
import {useParams} from "react-router";
import ProductInfo from "@components/Product/ProductForm/ProductInfo";
import {hideSpinner, showSpinner} from "@redux/spinner/Action";
import {useDispatch} from "react-redux";
import ProductHeader from "@components/Product/ProductForm/ProductHeader";
import ProductPlan from "@components/Product/ProductForm/ProductPlan";
import {useHistory} from "react-router-dom";

const ProductForm = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {id} = useParams();

  const checkID = () => {
    if (!id) {
      return history.push('/');
    }
  }

  useEffect(() => {
    checkID();
  }, [checkID]);

  const [showModal, setShowModal] = useState(false);
  const [product, setProduct] = useState({});
  const [plans, setPlans] = useState([]);
  const [selectedColor, setSelectedColor] = useState({});
  const [selectedMemory, setSelectedMemory] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectedTimeline, setSelectedTimeline] = useState(null);
  const [selectedInstallment, setSelectedInstallment] = useState(null);
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState('preorder');
  const [saveAmount, setSaveAmount] = useState(null);
  const [lowestInstallment, setLowestInstallment] = useState(null);

  const total = useMemo(() => {
    return Number(product.price)
      + Number(selectedColor?.additional_fee || 0)
      + Number(selectedMemory?.additional_fee || 0)
  }, [product, selectedColor, selectedMemory])

  useEffect(() => {
    dispatch(showSpinner('Please wait...'))
    setLoading(true)
    API.get(`preorder-campaign/product/${id}`).then(({data}) => {
      setSaveAmount(data.max_save_amount)
      setLowestInstallment(data.lowest_installment)
      setSelectedColor(data.product?.colors[0])
      setSelectedMemory(data.product?.colors[0]?.memories[0])
      setProduct(data.product)
      setPlans(data.plans)
      setCities(data.cities)
    }).finally(() => {
      dispatch(hideSpinner());
      setLoading(false)
    });
  }, [dispatch, id]);

  return (
    <div style={{maxWidth: '1024px'}}>
      {loading ? <div style={{height: "100vh"}}/> : <div className="md:mx-5">
      {showModal && (
        <BlankModal>
          <div className={'flex flex-col justify-center items-center p-5'}>
            <ProductInfo product={product}/>
          </div>
          <AiOutlineCloseCircle
            size={20}
            className={'absolute top-3 right-5 text-gray-600 cursor-pointer'}
            onClick={() => setShowModal(false)}
          />
        </BlankModal>
      )}
      <ProductHeader
        product={product}
        selectedColor={selectedColor}
        setSelectedColor={setSelectedColor}
        selectedMemory={selectedMemory}
        setSelectedMemory={setSelectedMemory}
        showModal={showModal}
        setShowModal={setShowModal}
        step={step}
        total={total}
        selectedPlan={selectedPlan}
        selectedTimeline={selectedTimeline}
        selectedInstallment={selectedInstallment}
      />
        <ProductPlan
          product={product}
          cities={cities}
          saveAmount={saveAmount}
          lowestInstallment={lowestInstallment}
          plans={plans}
          selectedPlan={selectedPlan}
          onPlanSelect={setSelectedPlan}
          total={total}
          selectedTimeline={selectedTimeline}
          onTimelineSelect={setSelectedTimeline}
          selectedInstallment={selectedInstallment}
          onInstallmentSelect={setSelectedInstallment}
          step={step} setStep={(e) => setStep(e)}
          selectedColor={selectedColor}
          selectedMemory={selectedMemory}/>
        </div>}
    </div>
  );
}

export default ProductForm;
